var _path, _path2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgPen(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.41455 16.4487H4.14063C3.98523 16.4487 3.83619 16.387 3.72631 16.2771C3.61642 16.1672 3.55469 16.0182 3.55469 15.8628V12.5889C3.55442 12.5128 3.56917 12.4374 3.59807 12.367C3.62698 12.2966 3.66948 12.2326 3.72315 12.1787L12.5122 3.38965C12.5667 3.33428 12.6317 3.29032 12.7034 3.26031C12.7751 3.2303 12.852 3.21484 12.9297 3.21484C13.0074 3.21484 13.0843 3.2303 13.156 3.26031C13.2277 3.29032 13.2926 3.33428 13.3472 3.38965L16.6138 6.65625C16.6691 6.71077 16.7131 6.77576 16.7431 6.84743C16.7731 6.9191 16.7886 6.99603 16.7886 7.07373C16.7886 7.15143 16.7731 7.22835 16.7431 7.30003C16.7131 7.3717 16.6691 7.43669 16.6138 7.49121L7.82471 16.2803C7.77078 16.3339 7.70679 16.3764 7.63641 16.4053C7.56603 16.4343 7.49064 16.449 7.41455 16.4487Z",
    stroke: "#21BB8E",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M10.5859 5.3125L14.6875 9.41406",
    stroke: "#21BB8E",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPen);
export default __webpack_public_path__ + "static/media/pen.b13ae015.svg";
export { ForwardRef as ReactComponent };